import type { ComponentProps } from 'react';
import React from 'react';
import styled from '@emotion/styled';
import type { BorderProps, MaxHeightProps, SpaceProps } from 'styled-system';
import { border, maxHeight, space } from 'styled-system';

import { BodyBoldBB2, HeadlineH7 } from 'common/components/Typography';
import { textWithEllipsis } from 'common/theme/styles';
import type { TextTransformProps } from 'common/theme/system-utilities';
import { textTransform } from 'common/theme/system-utilities';

interface ContentProps {
  headline: string;
  subtitle: string;
}

const Container = styled.div<SpaceProps & BorderProps>`
  ${space};
  ${border};
`;

const containerStyles: ComponentProps<typeof Container> = {
  pl: ['sp_16', 'sp_24', 'sp_16'],
  pr: ['sp_16', 'sp_24', 'sp_16'],
  py: 'sp_8',
  m: 'auto 0',
};

export const Headline = styled(BodyBoldBB2)<TextTransformProps>`
  ${textTransform};
  ${textWithEllipsis(1)};
`;

const headlineStyles: ComponentProps<typeof Headline> = {
  color: 'sys.neutral.border.default',
  textTransform: 'uppercase',
};

const Subtitle = styled(HeadlineH7)<MaxHeightProps>`
  ${textWithEllipsis(3)};
  ${maxHeight};
`;

const Content = ({ headline, subtitle, ...props }: ContentProps) => (
  <Container {...containerStyles} {...props}>
    <Headline {...headlineStyles}>{headline}</Headline>
    <Subtitle>{subtitle}</Subtitle>
  </Container>
);

export default Content;
